exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.Icons_ContactVerificationIcon_1Zeir {\n    font-size: 12px;\n    font-weight: bold;\n    color: green;\n    padding-left: 2px;\n    padding-top: 2px;\n    line-height: 1.6;\n}\n.Icons_ContactVerificationIcon_1Zeir > span {\n    font-family: sans-serif;\n    padding-left: 2px;\n}", ""]);

// Exports
exports.locals = {
	"ContactVerificationIcon": "Icons_ContactVerificationIcon_1Zeir"
};